"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsSystemSettings = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _DmsForm = require("../../components/DmsForm/DmsForm");
var _reactIntlUniversal = _interopRequireDefault(require("react-intl-universal"));
var _VirtualKeyboard = require("../../constants/VirtualKeyboard");
var _Locales = require("../../constants/Locales");
var _DmsSelect = require("../../components/DmsSelect/DmsSelect");
var _material = require("@mui/material");
var _DmsFetch = require("../../components/DmsFetch/DmsFetch");
var _HttpStatus = require("../../constants/HttpStatus");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/**
 * DmsSystemSettings component renders the system settings form with language and keyboard options.
 * 
 * @component
 * @example
 * return (
 *   <DmsSystemSettings />
 * )
 */
const DmsSystemSettings = () => {
  const [language, setLanguage] = (0, _react.useState)(null);
  const [useKeyboard, setUseKeyboard] = (0, _react.useState)(null);
  const [loading, setLoading] = (0, _react.useState)(true);
  const options = Object.entries(_Locales.LOCALES_FLAG).map(_ref => {
    let [label, value] = _ref;
    return {
      value,
      label
    };
  });
  (0, _react.useEffect)(() => {
    const fetchSystemSettings = async () => {
      try {
        var _systemSettings$data$, _systemSettings$data, _systemSettings$data$2, _systemSettings$data2;
        const {
          data: systemSettings
        } = await (0, _DmsFetch.fetchData)('/system_settings', 'get', true);
        setLanguage((_systemSettings$data$ = systemSettings === null || systemSettings === void 0 || (_systemSettings$data = systemSettings.data) === null || _systemSettings$data === void 0 ? void 0 : _systemSettings$data.language) !== null && _systemSettings$data$ !== void 0 ? _systemSettings$data$ : '-');
        setUseKeyboard((_systemSettings$data$2 = systemSettings === null || systemSettings === void 0 || (_systemSettings$data2 = systemSettings.data) === null || _systemSettings$data2 === void 0 ? void 0 : _systemSettings$data2.keyboard) !== null && _systemSettings$data$2 !== void 0 ? _systemSettings$data$2 : '-');
      } catch (error) {
        console.error('Error fetching system settings:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchSystemSettings();
  }, []);
  if (loading) {
    return /*#__PURE__*/_react.default.createElement(_material.Box, {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "100vh"
    }, /*#__PURE__*/_react.default.createElement(_material.CircularProgress, null), /*#__PURE__*/_react.default.createElement(_material.Typography, {
      variant: "h6",
      style: {
        marginLeft: '10px'
      }
    }, _reactIntlUniversal.default.get("LoadingSettingsdots").d("Loading Settings...")));
  }
  return /*#__PURE__*/_react.default.createElement(_DmsForm.DmsForm, {
    onSubmit: submitAndChangeCurrentBackLang
  }, /*#__PURE__*/_react.default.createElement(_DmsForm.DmsForm.Body, null, /*#__PURE__*/_react.default.createElement(_material.Grid, {
    container: true,
    spacing: 2
  }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    xs: 12,
    sm: 4
  }, /*#__PURE__*/_react.default.createElement(_DmsSelect.DmsSelect, {
    name: "language",
    label: _reactIntlUniversal.default.get("SystemLanguage").d("System Language"),
    options: options,
    value: language,
    onChange: e => setLanguage(e),
    fullWidth: true
  })), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    xs: 12,
    sm: 4
  }, /*#__PURE__*/_react.default.createElement(_DmsSelect.DmsSelect, {
    name: "keyboard",
    label: _reactIntlUniversal.default.get("Keyboard").d("Keyboard"),
    options: _VirtualKeyboard.VirtualKeyboardEnum,
    value: useKeyboard,
    onChange: e => setUseKeyboard(e),
    fullWidth: true
  })))));
};
exports.DmsSystemSettings = DmsSystemSettings;
DmsSystemSettings.propTypes = {
  language: _propTypes.default.string,
  useKeyboard: _propTypes.default.string
};

// In DmsSystemSettings.js

/**
 * Save the form Settings (Language/keyboard) and change the current
 * Backend language, so it is not necessary to reload the backend
 */
const submitAndChangeCurrentBackLang = async formData => {
  const url_sys_settings = "/system_settings";
  const url_set_be_translation = "/set_backend_translation";
  const method = "PUT";
  return (0, _DmsFetch.fetchData)(url_sys_settings, method, true, formData).then(response => {
    const isSuccess = (response === null || response === void 0 ? void 0 : response.status) === _HttpStatus.HTTP_STATUS.OK_200 || (response === null || response === void 0 ? void 0 : response.status) === _HttpStatus.HTTP_STATUS.CREATED_201;
    if (isSuccess) {
      window.dispatchEvent(new CustomEvent('system-settings-changed'));
    }
    return isSuccess ? (0, _DmsFetch.fetchData)(url_set_be_translation, method, true, formData['language'], false, null, null, null, "application/json") : response;
  });
};